// Time zones
export const Timezones = {
  PORTAL_TZ: 'portalTz',
  USER_TZ: 'userTz'
};
// Momentjs units
export const MomentUnits = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year'
};
export const WEEKDAYS_AS_INTS = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
};
// Unified Events frequencies
export const UEFrequencies = {
  DAILY: 'd',
  WEEKLY: 'w',
  WEEKLY_STARTING_MONDAY: 'wsm',
  MONTHLY: 'm',
  QUARTERLY: 'q',
  YEARLY: 'y',
  ALL_TIME: 'a'
};
export const SUPPORTED_UE_FREQUENCY_OPTIONS = [UEFrequencies.DAILY, UEFrequencies.WEEKLY, UEFrequencies.MONTHLY, UEFrequencies.QUARTERLY, UEFrequencies.YEARLY];

// Old performance page buckets
export const REPORTING_BUCKETS = {
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH'
};
// unit conversions
export const REPORTING_BUCKET_TO_MOMENT_UNIT = {
  [REPORTING_BUCKETS.DAY]: MomentUnits.DAY,
  [REPORTING_BUCKETS.WEEK]: MomentUnits.WEEK,
  [REPORTING_BUCKETS.MONTH]: MomentUnits.MONTH
};
export const UE_FREQUENCY_TO_MOMENT_UNIT = {
  [UEFrequencies.DAILY]: MomentUnits.DAY,
  [UEFrequencies.WEEKLY]: MomentUnits.WEEK,
  [UEFrequencies.WEEKLY_STARTING_MONDAY]: MomentUnits.WEEK,
  [UEFrequencies.MONTHLY]: MomentUnits.MONTH,
  [UEFrequencies.QUARTERLY]: MomentUnits.QUARTER,
  [UEFrequencies.YEARLY]: MomentUnits.YEAR
};
export const MOMENT_UNIT_TO_UE_FREQUENCY = {
  [MomentUnits.DAY]: UEFrequencies.DAILY,
  [MomentUnits.WEEK]: UEFrequencies.WEEKLY,
  [MomentUnits.MONTH]: UEFrequencies.MONTHLY,
  [MomentUnits.QUARTER]: UEFrequencies.QUARTERLY,
  [MomentUnits.YEAR]: UEFrequencies.YEARLY
};

// formats
export const DateFormats = {
  DATEINT_FORMAT: 'YYYYMMDD',
  DATE_QUERY_PARAM_FORMAT: 'YYYY-MM-DD'
};